import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HeaderComponent} from './components/layout/header/header.component';
import {FooterComponent} from './components/layout/footer/footer.component';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {HtpInterceptor} from './shared/services/interceptor.service';
import {GlobalService} from './shared/services/global.service';
import {AlertService} from './shared/services/alert.service';
import {SnotifyModule, SnotifyService, ToastDefaults} from 'ng-snotify';
import {HomeComponent} from './components/pages/home/home.component';
import {AboutusComponent} from './components/pages/aboutus/aboutus.component';
import {NO_ERRORS_SCHEMA} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {VisionandmissionComponent} from './components/pages/visionandmission/visionandmission.component';
import {ActandstatutesComponent} from './components/pages/actandstatutes/actandstatutes.component';
import {BoardofresearchComponent} from './components/pages/boardofresearch/boardofresearch.component';
import {AffiliationsComponent} from './components/pages/affiliations/affiliations.component';
import {ChancellorComponent} from './components/pages/chancellor/chancellor.component';
import {VicechancellorComponent} from './components/pages/vicechancellor/vicechancellor.component';
import {DeanacademicComponent} from './components/pages/deanacademic/deanacademic.component';
import {RegistrarComponent} from './components/pages/registrar/registrar.component';
import {DeanrdComponent} from './components/pages/deanrd/deanrd.component';
import {CommitteesComponent} from './components/pages/committees/committees.component';
import {DswComponent} from './components/pages/dsw/dsw.component';
import {AntiraggComponent} from './components/pages/antiragg/antiragg.component';
import {ProgrammesComponent} from './components/pages/programmes/programmes.component';
import {PlacementComponent} from './components/pages/placement/placement.component';
import {InfrastructureComponent} from './components/pages/infrastructure/infrastructure.component';
import {ResearchComponent} from './components/pages/research/research.component';
import {AdmissionofficesComponent} from './components/pages/admissionoffices/admissionoffices.component';
import {BrouchureComponent} from './components/pages/brouchure/brouchure.component';
import {AdmissionformComponent} from './components/pages/admissionform/admissionform.component';
import {AcedamiccalendarComponent} from './components/pages/acedamiccalendar/acedamiccalendar.component';
import {RefundpolicyComponent} from './components/pages/refundpolicy/refundpolicy.component';
import {
    ExtracurricullaractivitiesComponent
} from './components/pages/extracurricullaractivities/extracurricullaractivities.component';
import {IqacComponent} from './components/pages/iqac/iqac.component';
import {IqacminutesComponent} from './components/pages/iqacminutes/iqacminutes.component';
import {InitiativereportsComponent} from './components/pages/initiativereports/initiativereports.component';
import {QualitymandatesComponent} from './components/pages/qualitymandates/qualitymandates.component';
import {MoocComponent} from './components/pages/mooc/mooc.component';
import {AsthomeComponent} from './components/pages/ast/asthome/asthome.component';
import {AstsyllabusComponent} from './components/pages/ast/astsyllabus/astsyllabus.component';
import {AstlabsComponent} from './components/pages/ast/astlabs/astlabs.component';
import {AstcontactusComponent} from './components/pages/ast/astcontactus/astcontactus.component';
import {AstcivilengineeringComponent} from './components/pages/ast/astcivilengineering/astcivilengineering.component';
import {
    AstmechanicalengineeringComponent
} from './components/pages/ast/astmechanicalengineering/astmechanicalengineering.component';
import {
    AstcomputerscienceengineeringComponent
} from './components/pages/ast/astcomputerscienceengineering/astcomputerscienceengineering.component';
import {AsteceComponent} from './components/pages/ast/astece/astece.component';
import {AstcybersecurityComponent} from './components/pages/ast/astcybersecurity/astcybersecurity.component';
import {AsbmchomeComponent} from './components/pages/asbmc/asbmchome/asbmchome.component';
import {AsbmcsyllabusComponent} from './components/pages/asbmc/asbmcsyllabus/asbmcsyllabus.component';
import {AsbmccontactComponent} from './components/pages/asbmc/asbmccontact/asbmccontact.component';
import {
    AsbmcbusinessstudiesComponent
} from './components/pages/asbmc/asbmcbusinessstudies/asbmcbusinessstudies.component';
import {AsbmccommerceComponent} from './components/pages/asbmc/asbmccommerce/asbmccommerce.component';
import {
    AsbmchotelmanagementandcateringComponent
} from './components/pages/asbmc/asbmchotelmanagementandcatering/asbmchotelmanagementandcatering.component';
import {AsahhomeComponent} from './components/pages/asah/asahhome/asahhome.component';
import {AsahsyllabusComponent} from './components/pages/asah/asahsyllabus/asahsyllabus.component';
import {AsahcontactComponent} from './components/pages/asah/asahcontact/asahcontact.component';
import {AsahenglishComponent} from './components/pages/asah/asahenglish/asahenglish.component';
import {AsaheducationComponent} from './components/pages/asah/asaheducation/asaheducation.component';
import {AsahlibraryscienceComponent} from './components/pages/asah/asahlibraryscience/asahlibraryscience.component';
import {
    AsahjournalismandmasscommunicationComponent
} from './components/pages/asah/asahjournalismandmasscommunication/asahjournalismandmasscommunication.component';
import {AsahfashiondesignComponent} from './components/pages/asah/asahfashiondesign/asahfashiondesign.component';
import {AsahyogascienceComponent} from './components/pages/asah/asahyogascience/asahyogascience.component';
import {
    AsahvocationalcourseComponent
} from './components/pages/asah/asahvocationalcourse/asahvocationalcourse.component';
import {AsbsbthomeComponent} from './components/pages/asbsbt/asbsbthome/asbsbthome.component';
import {AsbsbtsyllabusComponent} from './components/pages/asbsbt/asbsbtsyllabus/asbsbtsyllabus.component';
import {AsbsbtcontactComponent} from './components/pages/asbsbt/asbsbtcontact/asbsbtcontact.component';
import {
    AsbsbtphysicalscienceComponent
} from './components/pages/asbsbt/asbsbtphysicalscience/asbsbtphysicalscience.component';
import {
    AsbsbtlifeandalliedscienceComponent
} from './components/pages/asbsbt/asbsbtlifeandalliedscience/asbsbtlifeandalliedscience.component';
import {AsbsbtchemistryComponent} from './components/pages/asbsbt/asbsbtchemistry/asbsbtchemistry.component';
import {AsbsbtmathsComponent} from './components/pages/asbsbt/asbsbtmaths/asbsbtmaths.component';
import {AsahshomeComponent} from './components/pages/asahs/asahshome/asahshome.component';
import {AsahSyllabusComponent} from './components/pages/asahs/asah-syllabus/asah-syllabus.component';
import {AsahslabComponent} from './components/pages/asahs/asahslab/asahslab.component';
import {AsahscontactComponent} from './components/pages/asahs/asahscontact/asahscontact.component';
import {AsahsradiologyComponent} from './components/pages/asahs/asahsradiology/asahsradiology.component';
import {AsahsottComponent} from './components/pages/asahs/asahsott/asahsott.component';
import {AsahsanesthesiaComponent} from './components/pages/asahs/asahsanesthesia/asahsanesthesia.component';
import {AsahsoptometryComponent} from './components/pages/asahs/asahsoptometry/asahsoptometry.component';
import {AsahsmltComponent} from './components/pages/asahs/asahsmlt/asahsmlt.component';
import {AsahsphysiotherapyComponent} from './components/pages/asahs/asahsphysiotherapy/asahsphysiotherapy.component';
import {AsahsyogasciComponent} from './components/pages/asahs/asahsyogasci/asahsyogasci.component';
import {AsphomeComponent} from './components/pages/asp/asphome/asphome.component';
import {AspsyllabusComponent} from './components/pages/asp/aspsyllabus/aspsyllabus.component';
import {AsplabComponent} from './components/pages/asp/asplab/asplab.component';
import {AspcontactComponent} from './components/pages/asp/aspcontact/aspcontact.component';
import {AsppharmacyComponent} from './components/pages/asp/asppharmacy/asppharmacy.component';
import {AsahomeComponent} from './components/pages/asa/asahome/asahome.component';
import {AsasyllabusComponent} from './components/pages/asa/asasyllabus/asasyllabus.component';
import {AsacontactComponent} from './components/pages/asa/asacontact/asacontact.component';
import {AsalabComponent} from './components/pages/asa/asalab/asalab.component';
import {AsaagricultureComponent} from './components/pages/asa/asaagriculture/asaagriculture.component';
import {AslhomeComponent} from './components/pages/asl/aslhome/aslhome.component';
import {AslsyllabusComponent} from './components/pages/asl/aslsyllabus/aslsyllabus.component';
import {AsllabComponent} from './components/pages/asl/asllab/asllab.component';
import {AslcontactComponent} from './components/pages/asl/aslcontact/aslcontact.component';
import {AsllegalstudiesComponent} from './components/pages/asl/asllegalstudies/asllegalstudies.component';
import {AshtmhomeComponent} from './components/pages/ashmt/ashtmhome/ashtmhome.component';
import {AshmtsyllabusComponent} from './components/pages/ashmt/ashmtsyllabus/ashmtsyllabus.component';
import {AshmtcontactComponent} from './components/pages/ashmt/ashmtcontact/ashmtcontact.component';
import {AshmtlabComponent} from './components/pages/ashmt/ashmtlab/ashmtlab.component';
import {
    AshmttoursimandhospitalitymanagementComponent
} from './components/pages/ashmt/ashmttoursimandhospitalitymanagement/ashmttoursimandhospitalitymanagement.component';
import {AseshomeComponent} from './components/pages/ases/aseshome/aseshome.component';
import {AsessyllabusComponent} from './components/pages/ases/asessyllabus/asessyllabus.component';
import {AseslabsComponent} from './components/pages/ases/aseslabs/aseslabs.component';
import {AsescontactComponent} from './components/pages/ases/asescontact/asescontact.component';
import {
    AsescomputerapplicationComponent
} from './components/pages/ases/asescomputerapplication/asescomputerapplication.component';
import {FacultyinformationComponent} from './components/pages/facultyinformation/facultyinformation.component';
import {NonteachingstaffComponent} from './components/pages/nonteachingstaff/nonteachingstaff.component';
import {ScholarshipComponent} from './components/pages/scholarship/scholarship.component';
import {HostelgalleryComponent} from './components/pages/hostelgallery/hostelgallery.component';
import {HostelinfrastructureComponent} from './components/pages/hostelinfrastructure/hostelinfrastructure.component';
import {BusfacilityComponent} from './components/pages/busfacility/busfacility.component';
import {LibraryComponent} from './components/pages/library/library.component';
import {VideogalleryComponent} from './components/pages/videogallery/videogallery.component';
import {PhotogalleryComponent} from './components/pages/photogallery/photogallery.component';
import {GreencampuspolicyComponent} from './components/pages/greencampuspolicy/greencampuspolicy.component';
import {DatesheetComponent} from './components/pages/datesheet/datesheet.component';
import {InductionprogramComponent} from './components/pages/inductionprogram/inductionprogram.component';
import {StudentsurveyComponent} from './components/pages/studentsurvey/studentsurvey.component';
import {ResearchunitComponent} from './components/pages/researchunit/researchunit.component';
import {StudentinfodetailComponent} from './components/pages/studentinfodetail/studentinfodetail.component';
import {ContactComponent} from './components/pages/contact/contact.component';
import {CareerComponent} from './components/pages/career/career.component';
import {NewsComponent} from './components/pages/news/news.component';
import {EnquiryComponent} from './components/pages/enquiry/enquiry.component';
import {LightboxModule} from 'ngx-lightbox';
import { BlogComponent } from './components/pages/blog/blog.component';
import { BlogDetailComponent } from './components/pages/blog-detail/blog-detail.component';
import { SecurityAndDisplineComponent } from './components/pages/security-and-displine/security-and-displine.component';
import { CircularNoticeComponent } from './components/pages/circular-notice/circular-notice.component';
import { OnlineEducationComponent } from './components/pages/online-education/online-education.component';
import { OnlineExamComponent } from './components/pages/online-exam/online-exam.component';
import { CafeteriaComponent } from './components/pages/cafeteria/cafeteria.component';
import { MessComponent } from './components/pages/mess/mess.component';
import { PrivacyPolicyComponent } from './components/pages/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './components/pages/terms-and-conditions/terms-and-conditions.component';
import { ConferenceComponent } from './components/pages/conference/conference.component';
import { AstcomputerscienceapplicationComponent } from './components/pages/ast/astcomputerscienceapplication/astcomputerscienceapplication.component';

@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        HomeComponent,
        AboutusComponent,
        VisionandmissionComponent,
        ActandstatutesComponent,
        BoardofresearchComponent,
        AffiliationsComponent,
        ChancellorComponent,
        VicechancellorComponent,
        DeanacademicComponent,
        RegistrarComponent,
        DeanrdComponent,
        CommitteesComponent,
        DswComponent,
        AntiraggComponent,
        ProgrammesComponent,
        PlacementComponent,
        InfrastructureComponent,
        ResearchComponent,
        AdmissionofficesComponent,
        BrouchureComponent,
        AdmissionformComponent,
        AcedamiccalendarComponent,
        RefundpolicyComponent,
        ExtracurricullaractivitiesComponent,
        IqacComponent,
        IqacminutesComponent,
        InitiativereportsComponent,
        QualitymandatesComponent,
        MoocComponent,
        AsthomeComponent,
        AstsyllabusComponent,
        AstlabsComponent,
        AstcontactusComponent,
        AstcivilengineeringComponent,
        AstmechanicalengineeringComponent,
        AstcomputerscienceengineeringComponent,
        AsteceComponent,
        AstcybersecurityComponent,
        AsbmchomeComponent,
        AsbmcsyllabusComponent,
        AsbmccontactComponent,
        AsbmcbusinessstudiesComponent,
        AsbmccommerceComponent,
        AsbmchotelmanagementandcateringComponent,
        AsahhomeComponent,
        AsahsyllabusComponent,
        AsahcontactComponent,
        AsahenglishComponent,
        AsaheducationComponent,
        AsahlibraryscienceComponent,
        AsahjournalismandmasscommunicationComponent,
        AsahfashiondesignComponent,
        AsahyogascienceComponent,
        AsahvocationalcourseComponent,
        AsbsbthomeComponent,
        AsbsbtsyllabusComponent,
        AsbsbtcontactComponent,
        AsbsbtphysicalscienceComponent,
        AsbsbtlifeandalliedscienceComponent,
        AsbsbtchemistryComponent,
        AsbsbtmathsComponent,
        AsahshomeComponent,
        AsahSyllabusComponent,
        AsahslabComponent,
        AsahscontactComponent,
        AsahsradiologyComponent,
        AsahsottComponent,
        AsahsanesthesiaComponent,
        AsahsoptometryComponent,
        AsahsmltComponent,
        AsahsphysiotherapyComponent,
        AsahsyogasciComponent,
        AsphomeComponent,
        AspsyllabusComponent,
        AsplabComponent,
        AspcontactComponent,
        AsppharmacyComponent,
        AsahomeComponent,
        AsasyllabusComponent,
        AsacontactComponent,
        AsalabComponent,
        AsaagricultureComponent,
        AslhomeComponent,
        AslsyllabusComponent,
        AsllabComponent,
        AslcontactComponent,
        AsllegalstudiesComponent,
        AshtmhomeComponent,
        AshmtsyllabusComponent,
        AshmtcontactComponent,
        AshmtlabComponent,
        AshmttoursimandhospitalitymanagementComponent,
        AseshomeComponent,
        AsessyllabusComponent,
        AseslabsComponent,
        AsescontactComponent,
        AsescomputerapplicationComponent,
        FacultyinformationComponent,
        NonteachingstaffComponent,
        ScholarshipComponent,
        HostelgalleryComponent,
        HostelinfrastructureComponent,
        BusfacilityComponent,
        LibraryComponent,
        VideogalleryComponent,
        PhotogalleryComponent,
        GreencampuspolicyComponent,
        DatesheetComponent,
        InductionprogramComponent,
        StudentsurveyComponent,
        ResearchunitComponent,
        StudentinfodetailComponent,
        ContactComponent,
        CareerComponent,
        NewsComponent,
        EnquiryComponent,
        BlogComponent,
        BlogDetailComponent,
        SecurityAndDisplineComponent,
        CircularNoticeComponent,
        OnlineEducationComponent,
        OnlineExamComponent,
        CafeteriaComponent,
        MessComponent,
        PrivacyPolicyComponent,
        TermsAndConditionsComponent,
        ConferenceComponent,
        AstcomputerscienceapplicationComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        HttpClientModule,
        SnotifyModule,
        FormsModule,
        BrowserAnimationsModule,
        LightboxModule
    ],
    providers: [HtpInterceptor,
        GlobalService,
        AlertService,
        {provide: 'SnotifyToastConfig', useValue: ToastDefaults},
        SnotifyService],
    exports: [],
    bootstrap: [AppComponent],
    schemas: [NO_ERRORS_SCHEMA]
})
export class AppModule {
}
